<!-- AuthorizationItems.vue -->
<script setup lang="ts">
    import { ITimelineElectronicAuthorization, ITimelineManualAuthorization } from '../../lib/Models/EMR/TimelineModel';
    import { ICol } from '../../lib/ChoiceTableHelpers';
    import { NoTzDate } from '../../lib/DateUtils';
    import { ActionButtonStyle } from '../../lib/Types/Types'
    import { ButtonDisplaySize, DisplayStyle } from '../../Enums/UiEnums'
    import FoldingPanel from '../../components/FoldingPanel.vue'
    import ChoiceTable from '../../components/ChoiceTable.vue'
    import ChoiceButton from '../../components/Buttons/ChoiceButton.vue'
    import MessageBadge from '../../components/Messages/MessageBadge.vue';

    const props = defineProps<{
        manualAuthorizationItems?: ITimelineManualAuthorization[],
        electronicAuthorizationItems?: ITimelineElectronicAuthorization[],
        itemsDate: NoTzDate
    }>();

    const emit = defineEmits<{
        showManual: [itemsDate: NoTzDate],
        showElectronic: [item: ITimelineElectronicAuthorization],
    }>();

    const manualAuthorizationColumns: ICol[] = [
        { Name: "", DataField: "authorizationId", ExtraData: "actionButton"},
        { Name: "Reason", DataField: "reason"},
    ];

    const electronicAuthorizationColumns: ICol[] = [
        { Name: "", ExtraData: "actionButton"},
        { Name: "Status", DataField:"ePATaskStatus" },
        { Name: "Drug Name", DataField:"drugShortName" },
        { Name: "Provider", DataField: "providerName" },
        { Name: "Written", DataField: "writtenDate" }
    ];

    function onClickViewManualAuthInfo()
    {
        emit("showManual", props.itemsDate);
    }

    function onClickViewElectronicAuthInfo(authItem: ITimelineElectronicAuthorization)
    {
        emit("showElectronic", authItem);
    }
</script>

<template>
    <FoldingPanel v-if="manualAuthorizationItems?.length">
        <template #title>
            Manual Authorization
            <MessageBadge :displayStyle="DisplayStyle.Light">{{manualAuthorizationItems.length}}</MessageBadge>
        </template>
        <template #body>
            <ChoiceTable :columns="manualAuthorizationColumns" :data="manualAuthorizationItems">
                <template #cell="{col, value}">
                    <ChoiceButton v-if="'actionButton' === col.ExtraData" :action="ActionButtonStyle.Open" text="" title="View manual authorization info" @click="onClickViewManualAuthInfo" />
                </template>
            </ChoiceTable>
        </template>
    </FoldingPanel>

    <FoldingPanel v-if="electronicAuthorizationItems?.length">
        <template #title>
            Electronic Authorization
            <MessageBadge :displayStyle="DisplayStyle.Light">{{electronicAuthorizationItems.length}}</MessageBadge>
        </template>
        <template #body>
            <ChoiceTable :columns="electronicAuthorizationColumns" :data="electronicAuthorizationItems">
                <template #cell="{col, row}">
                    <ChoiceButton v-if="'actionButton' === col.ExtraData" 
                        :size="ButtonDisplaySize.Small"
                        :action="ActionButtonStyle.Open" 
                        text="" title="View electronic authorization info" 
                        @click="() => onClickViewElectronicAuthInfo(row as ITimelineElectronicAuthorization)" />
                </template>
            </ChoiceTable>
        </template>
    </FoldingPanel>
</template>